import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type ContactsOptInModalLocalStore } from 'widgets/ContactsOptInModal/store/contactsOptInModalLocalStore'

type IContactsOptInModalActionsProps = {
  store: ContactsOptInModalLocalStore
}

export const ContactsOptInModalActions: FC<IContactsOptInModalActionsProps> = observer(
  ({ store }) => {
    const { handleSaveUndo, disabled } = store

    return (
      <Button
        typeBtn={'contained'}
        text={'Save'}
        disabled={disabled}
        onClick={() => {
          handleSaveUndo()
        }}
      />
    )
  }
)
